@if (isStandardView) {
    <app-admin-report-template-list />
}
